/**
 * Production-safe logger utility.
 * In production, errors are silently captured.
 * In development, they log to console.
 */
const isDev = process.env.NODE_ENV === 'development';

const logger = {
    error: (...args) => { if (isDev) console.error(...args); },
    warn: (...args) => { if (isDev) console.warn(...args); },
    info: (...args) => { if (isDev) console.info(...args); },
};

export default logger;
